(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avresa-atelier"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('avresa-atelier'))customElements.define('avresa-atelier',class extends HTMLElement{
    connectedCallback(){
      this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=!!window.Shopify?.designMode;this.hover=false;this.focused=false;this.visible=true;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.controller=new AbortController();const signal=this.controller.signal;
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1),{signal});
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1),{signal});
      this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.paused=!this.paused;this.setAttribute('data-paused','');if(!this.paused)this.removeAttribute('data-paused');this.querySelector('[data-pause]').setAttribute('aria-pressed',String(this.paused));this.querySelector('[data-pause-icon]').textContent=this.paused?'▶':'Ⅱ';this.schedule()},{signal});
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule()}},{signal});this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule()},{signal});
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},{signal});this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule()})},{signal});
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+((e.key==='ArrowRight'?1:-1)*(this.dir==='rtl'?-1:1)))}},{signal});
      let start;const stage=this.querySelector('.av-slides');stage.addEventListener('touchstart',e=>{start={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}},{passive:true,signal});stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1)*(this.dir==='rtl'?-1:1));start=null},{passive:true,signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.motion.addEventListener('change',()=>this.schedule(),{signal});
      this.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-slide]');if(slide){this.paused=true;this.setAttribute('data-paused','');this.go(this.slides.indexOf(slide))}},{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:.1});this.observer.observe(this);if(this.paused)this.setAttribute('data-paused','');this.schedule();
    }
    go(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active))});const counter=this.querySelector('[data-current]');if(counter)counter.textContent=String(this.index+1).padStart(2,'0');this.schedule()}
    schedule(){clearTimeout(this.timer);if(this.dataset.autoplay==='true'&&this.slides.length>1&&!this.paused&&!this.hover&&!this.focused&&!this.motion.matches&&!document.hidden&&this.visible)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval)||6500)}
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.observer?.disconnect()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
